import CryptoJS from 'crypto-js';

export const aesEncrypt = (strToEncrypt) => {
    const osType = getOSType();
    console.log("osTypeosTypeosTypeosType",osType);
    let dataEncrypt = {};
    let dkey = '';
    let div = '';

  switch (osType) {
    case 'Web':
      dataEncrypt = { sha_key: 'gaadibazaar@key@login@web', date: new Date() };
      dkey = 'ga0d!bazaor@web@token@login';
      div = '2610343231299078';
      break;
    case 'ios':
      dataEncrypt = { sha_key: 'gaadibazaar@key@login@ios', date: new Date() };
      dkey = 'ga0d!bazaor@ios@token@login@2014';
      div = '2667602312990789';
      break;
    case 'android':
      dataEncrypt = { sha_key: 'gaadibazaar@key@login@android', date: new Date() };
      dkey = 'ga0d!bazaor@android@token@login';
      div = '2121210231299078';
      break;
    default:
      return '';
  }

  dataEncrypt = { ...dataEncrypt, mobile_number: strToEncrypt };
  const jsonString = JSON.stringify(dataEncrypt);

  if (!jsonString) return '';

  const hashedKey = CryptoJS.SHA256(dkey).toString(CryptoJS.enc.Hex).substring(0, 32);
  const hashedIv = CryptoJS.SHA256(div).toString(CryptoJS.enc.Hex).substring(0, 32);

  const key = CryptoJS.enc.Hex.parse(hashedKey);
  const iv = CryptoJS.enc.Hex.parse(hashedIv);

  const encrypted = CryptoJS.AES.encrypt(jsonString, key, {
    mode: CryptoJS.mode.CBC,
    iv: iv,
  });

  return encrypted.toString();
};

export const getOSType = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
    if (/android/i.test(userAgent)) {
      return 'android';
    }
  
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'ios';
    }
  
    return 'Web';
  };


export const camelize = (str) => {
  return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
    return index === 0 ? word.toUpperCase() : word.toLowerCase();
  }).replace(/\s+/g, '');
}

export const dateConvert = (date) => {
  const rawDate = date;
  const dateObj = new Date(rawDate);
  const formattedDate = dateObj.toLocaleDateString('en-GB', {
  day: '2-digit',
  month: 'short',
  year: 'numeric'
  });

  return formattedDate;
}

export const handleDownload = (url, filename = 'certificate.pdf') => {
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// export const isEncrypted = (str,src) => {
//   try {
//     // Try decoding Base64
//     const decoded = atob(str);

//     // Check if decoded string has a reasonable length (AES block size is 16 bytes)
//     let verified = decoded.length >= 16;
//    if(src){
//       let request = {mobile:str,web:true,src:src};
//    }
//     let request = {mobile:str,web:true};
//     if(verified){
//       request = {mobile:str,web:false};
//     }
//     return request;
//   } catch (e) {
//     // If decoding fails, it's not valid Base64
//     return false;
//   }
// };

export const isEncrypted = (str, src, clnt) => {
  try {
    console.log("strstr",str);
    console.log("srcsrc",src);
    console.log("clnt",clnt);

    if(!src){
      src  = JSON.parse(localStorage.getItem('src') || '""');
    }

    if(!clnt){
      clnt = JSON.parse(localStorage.getItem('clnt') || '""');
    }

    console.log("src from local",src);
    console.log("clnt from local",clnt);
    // Try decoding Base64
    const decoded = atob(str);

    // Check if decoded string has a reasonable length (AES block size is 16 bytes)
    const verified = decoded.length >= 16;

    // Default request
    let request = { mobile: str, web: true };

    // If encrypted, update web flag
    if (verified) {
      request.web = false;
    }

    // If src is provided, add it to the request
    if (src) {
      request.src = src;
    }

    // If src is provided, add it to the request
    if (clnt) {
       request.clnt = clnt;
    }
    console.log("requestrequest",request);
    return request;
  } catch (e) {
    // If decoding fails, it's not valid Base64
    return false;
  }
};

export const parseMobileParams = () => {
  const params = new URLSearchParams(window.location.search);
  console.log("paramsparams",params);
  let mobileNumber = params.get('mobile');
  let source = params.get('src');
  let client = params.get('clnt');

  if(source && client){
    localStorage.setItem('clnt', JSON.stringify(client));
    localStorage.setItem('src', JSON.stringify(source));
  }

  if (mobileNumber) {
    mobileNumber = mobileNumber.replace(/ /g, '+');
    const verifiedData = isEncrypted(mobileNumber, source, client);
    return {
      mobileNumber,
      source,
      client,
      verifiedData,
    };
  }

  return null;
};



  
